module.exports = __webpack_public_path__ + "img/banner_bg2.4aa1fc68.jpg";